import css from "styled-jsx/css";

export const componentStyles = css.global`
  .square-tags {
    margin: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
    justify-content: center;

    .clusters-stars {
      margin-top: 48px;
      margin-bottom: 56px;
      display: flex;

      .star-wrapper {
        width: 140px;
        position: relative;
        user-select: none;
      }
    }

    .button-wrapper {
      transform: scale(1);
      button.signup-button {
        background-image: var(--background);
        color: var(--text-color);
        &:disabled {
          background-image: var(--background);
          color: var(--text-color);
        }
      }
      &.cluster-selected {
        animation: breatheOut 0.3s linear;
      }
    }
  }

  @keyframes breatheOut {
    0% {
      transform: scale(1);
    }

    15% {
      transform: scale(1.01);
    }

    20% {
      transform: scale(1.02);
    }

    25% {
      transform: scale(1.03);
    }

    32% {
      transform: scale(1.04);
    }

    50% {
      transform: scale(1.05);
    }

    68% {
      transform: scale(1.04);
    }

    75% {
      transform: scale(1.03);
    }

    80% {
      transform: scale(1.02);
    }

    85% {
      transform: scale(1.01);
    }

    100% {
      transform: scale(1);
    }
  }
`;
